// extracted by mini-css-extract-plugin
export default {"mergeTable":"styles_mergeTable__xJYYD","mergeDialog":"styles_mergeDialog__CNlV4","mergeConflictRow":"styles_mergeConflictRow__Ume8Q"};